import { render, staticRenderFns } from "./PaymentAccount.vue?vue&type=template&id=12332f12&"
import script from "./PaymentAccount.vue?vue&type=script&lang=js&"
export * from "./PaymentAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports